// 运输模式数组（默认值，会被接口数据覆盖）
let deliverModeArr = [] // 查询条件时 - 带全部
let deliverModeArr_normal = [] // 不带全部

const seasonArr = [
    {label: '全部', value: undefined},
    {label: 'Q1', value: 'Q1'},
    {label: 'Q2', value: 'Q2'},
    {label: 'Q3', value: 'Q3'},
    {label: 'Q4', value: 'Q4'},
    {label: 'Q1|Q2', value: 'Q1|Q2'},
    {label: 'Q1|Q3', value: 'Q1|Q3'},
    {label: 'Q1|Q4', value: 'Q1|Q4'},
    {label: 'Q2|Q3', value: 'Q2|Q3'},
    {label: 'Q2|Q4', value: 'Q2|Q4'},
    {label: 'Q3|Q4', value: 'Q3|Q4'},
    {label: 'Q1|Q2|Q3', value: 'Q1|Q2|Q3'},
    {label: 'Q1|Q2|Q4', value: 'Q1|Q2|Q4'},
    {label: 'Q1|Q3|Q4', value: 'Q1|Q3|Q4'},
    {label: 'Q2|Q3|Q4', value: 'Q2|Q3|Q4'},
    {label: 'Q1|Q2|Q3|Q4', value: 'Q1|Q2|Q3|Q4'},
]
const seasonArrNoDefault = [
    {label: 'Q1', value: 'Q1'},
    {label: 'Q2', value: 'Q2'},
    {label: 'Q3', value: 'Q3'},
    {label: 'Q4', value: 'Q4'},
    {label: 'Q1|Q2', value: 'Q1|Q2'},
    {label: 'Q1|Q3', value: 'Q1|Q3'},
    {label: 'Q1|Q4', value: 'Q1|Q4'},
    {label: 'Q2|Q3', value: 'Q2|Q3'},
    {label: 'Q2|Q4', value: 'Q2|Q4'},
    {label: 'Q3|Q4', value: 'Q3|Q4'},
    {label: 'Q1|Q2|Q3', value: 'Q1|Q2|Q3'},
    {label: 'Q1|Q2|Q4', value: 'Q1|Q2|Q4'},
    {label: 'Q1|Q3|Q4', value: 'Q1|Q3|Q4'},
    {label: 'Q2|Q3|Q4', value: 'Q2|Q3|Q4'},
    {label: 'Q1|Q2|Q3|Q4', value: 'Q1|Q2|Q3|Q4'},
]
// 默认的运营状态数据（初始值，会被接口数据覆盖）
let us_arr = [] // 查询条件时 - 带全部
let us_arr_normal = [] // 不带全部

// 链接制作状态下拉选项（组件使用时自行添加「全部」选项，全部的 value 有 undefined / null 两种）
const linkProductionStatusArr = [
    {label: '待生成', value: 0},
    {label: '准备开始生成', value: 4},
    {label: '生成文件完成', value: 1},
    {label: '上传文件完成', value: 2},
    {label: 'SKU生成完成', value: 3},
    {label: '生成关键词', value: 5},
    {label: '生成链接相应数据', value: 6},
    {label: '生成文件失败', value: -1},
    {label: '上传文件失败', value: -2},
    {label: 'SKU生成失败', value: -3},
    {label: '未找到模板', value: -4},
]
// 链接制作状态文案映射（由上面的选项数组生成，key 为字符串）
const linkProductionStatusMap = linkProductionStatusArr.reduce((map, item) => {
    map[String(item.value)] = item.label
    return map
}, {})

export default {
    deliverModeArr,
    seasonArrNoDefault,
    seasonArr,
    us_arr,
    us_arr_normal,
    linkProductionStatusMap,
    linkProductionStatusArr
}
